/* eslint-disable no-useless-escape */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
import React from 'react';
import Loader from 'react-loader-spinner';
import FileSaver, { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import {
  Document, Packer, Paragraph, HeadingLevel, AlignmentType, Header,
} from 'docx';
import { toastError } from '../redux/actions/alertActions';

const min2time = (timeInSeconds) => {
  // eslint-disable-next-line func-names
  const pad = function (num, size) { return (`000${num}`).slice(size * -1); };
  const time = parseFloat(timeInSeconds).toFixed(3);
  const hours = Math.floor(time / 60 / 60);
  const minutes = Math.floor(time / 60) % 60;

  return `${pad(hours, hours > 99 ? 3 : 2)}h${pad(minutes, 2)}`;
};

const sec2time = (timeInSeconds) => {
  const pad = (num, size) => (`000${num}`).slice(size * -1);
  const time = parseFloat(timeInSeconds).toFixed(3);
  const hours = Math.floor(time / 60 / 60);
  const minutes = Math.floor(time / 60) % 60;

  return `${pad(hours, hours > 99 ? 3 : 2)}h${pad(minutes, 2)}`;
};

const time2min = (timeInhour) => {
  const arrayhoursSecond = timeInhour.split('h');
  const hours = parseInt(arrayhoursSecond[0], 10);
  const minutes = parseInt(arrayhoursSecond[1], 10);
  const finalSec = hours * 60 + minutes;

  return finalSec;
};

const addUnitTimers = (trackers) => {
  let totalTime = 0;

  trackers.forEach((tracker) => {
    totalTime += tracker.time;
  });
  return totalTime;
};

const convertCEFRToElearningLevel = (cefr) => {
  let level;

  if ((cefr === 'A0') || (cefr === 'A1') || (cefr === 'A2')) {
    level = 1;
  } else {
    level = 2;
  }
  return level;
};

const checkFields = (fieldArray) => {
  let isError = false;
  for (const field in fieldArray) {
    if (!fieldArray[field] && fieldArray[field] !== false) {
      toastError(`Error with field ${field}`);
      isError = true;
    }
  }
  if (isError === true) return (false);
  return (true);
};

const Loading = () => (
  <div
    key="divProgress"
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <Loader type="TailSpin" color="#3F51B5" height={40} width={40} />
  </div>
);

const generateCsv = (dataArray, csvName) => {
  const csv = dataArray;
  const csvData = new Blob([csv], { type: 'text/csv;charset=utf-8;' });

  FileSaver.saveAs(csvData, `${csvName}.csv`);
};

function isFloat(n) {
  return Number(n) === n && n % 1 !== 0;
}

const numGradeToEUgrade = (intgrade) => {
  let eugrade = 'A0';

  if (intgrade && typeof (intgrade) === 'number') {
    if (intgrade >= 1 && intgrade < 3) eugrade = 'A1';
    else if (intgrade >= 3 && intgrade < 5) eugrade = 'A2';
    else if (intgrade >= 5 && intgrade < 7) eugrade = 'B1';
    else if (intgrade >= 7 && intgrade < 8) eugrade = 'B2';
    else if (intgrade >= 8 && intgrade < 9) eugrade = 'C1';
    else if (intgrade >= 9) eugrade = 'C2';

    if (isFloat(intgrade) && eugrade !== 'A0') {
      const decimal = Math.round((intgrade % 1) * 10);
      if (eugrade === 'B1') {
        const demiDecimal = Math.trunc((decimal / 2));
        eugrade += `.${intgrade < 6 ? demiDecimal.toString() : (5 + demiDecimal).toString()}`;
      } else {
        eugrade += `.${decimal}`;
      }
    }
    if (eugrade === 'B1' && intgrade === 6) {
      eugrade += '.5';
    }
  } else {
    eugrade = 'n/a';
  }

  return (eugrade);
};

const numGradeToEUgradeEW = (intgrade) => {
  let eugrade = 'Débutant';
  const grade = parseFloat(intgrade);
  if (grade && typeof (grade) === 'number') {
    if (grade >= 3 && grade < 4) eugrade = 'A1';
    else if (grade >= 4 && grade < 5) eugrade = 'A2';
    else if (grade >= 5 && grade < 7) eugrade = 'B1';
    else if (grade >= 7 && grade < 8) eugrade = 'B2';
    else if (grade >= 8 && grade < 9) eugrade = 'C1';
    else if (grade >= 9) eugrade = 'C2';
  } else {
    eugrade = 'n/a';
  }

  return (eugrade);
};

const levelToCEFR = (level) => {
  if (level === 0) {
    return 'Débutant';
  }
  if (level === 1) {
    return 'A1';
  }
  if (level === 2) {
    return 'A2';
  }
  if (level === 3) {
    return 'B1';
  }
  if (level === 4) {
    return 'B2';
  }
  if (level === 5) {
    return 'C1';
  }
  if (level === 6) {
    return 'C2';
  }
  return 'A0';
};

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
const FILE_EXTENSION = '.xlsx';

const saveAsExcel = (buffer, filename) => {
  const data = new Blob([buffer], { type: EXCEL_TYPE });
  saveAs(data, `${filename}${FILE_EXTENSION}`);
};

const exportXlsx = (data, title) => {
  const newExamData = JSON.parse(JSON.stringify(data));
  const worksheet = XLSX.utils.json_to_sheet(newExamData);
  const workbook = {
    Sheets: {
      data: worksheet,
    },
    SheetNames: ['data'],
  };

  const excelBuffer = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array',
  });

  saveAsExcel(excelBuffer, title);
};

const sanitizeSheetName = (name) => {
  const cleaned = (name || 'Sheet')
    .replace(/[\[\]\*\/\\\?\:]/g, ' ')
    .trim()
    .slice(0, 31);
  return cleaned.length ? cleaned : 'Sheet';
};

/**
 * sheets: Array<{ sheetName: string, data: any[] }>
 */
const exportXlsxMultiSheet = (sheets, fileName) => {
  const workbook = XLSX.utils.book_new();

  (sheets || []).forEach(({ sheetName, data }, index) => {
    const safeName = sanitizeSheetName(sheetName || `Sheet ${index + 1}`);

    const cloned = JSON.parse(JSON.stringify(data || []));
    const worksheet = XLSX.utils.json_to_sheet(cloned);

    XLSX.utils.book_append_sheet(workbook, worksheet, safeName);
  });

  const excelBuffer = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array',
  });

  saveAsExcel(excelBuffer, fileName);
};

const createXlsx = (data) => {
  const newExamData = JSON.parse(JSON.stringify(data));
  const worksheet = XLSX.utils.json_to_sheet(newExamData);
  const workbook = {
    Sheets: {
      data: worksheet,
    },
    SheetNames: ['data'],
  };

  const excelBuffer = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array',
  });

  const xlsx = new Blob([excelBuffer], { type: EXCEL_TYPE });
  return xlsx;
};

const saveDocumentToFile = (doc, fileName) => {
  const mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';

  Packer.toBlob(doc).then((blob) => {
    const docblob = blob.slice(0, blob.size, mimeType);

    saveAs(docblob, fileName);
  });
};

const generateWordDocument = (firstname, lastname, answer) => {
  // event.prenventDefault();

  const doc = new Document({
    styles: {
      paragraphStyles: [
        {
          id: 'answerStyle',
          name: 'Answer style',
          basedOn: 'Normal',
          run: {
            size: 26,
            font: 'Calibri',
          },
          paragraph: {
            spacing: { line: 276, before: 250, after: 150 },
          },
        },
      ],
    },
    sections: [
      {
        headers: {
          default: new Header({
            children: [
              new Paragraph(`Name: ${lastname}`),
              new Paragraph(`Firstname: ${firstname}`),
            ],
          }),
        },
        children: [
          new Paragraph({ text: 'Examen', heading: HeadingLevel.TITLE, alignment: AlignmentType.CENTER }),
          new Paragraph({
            children: [],
          }),
          new Paragraph({
            children: [],
          }),
          new Paragraph({ text: answer, style: 'answerStyle' }),
        ],
      },
    ],
  });

  saveDocumentToFile(doc, `${firstname}_${lastname}.docx`);
};

const types = [
  { label: 'IADE', value: 'IADE' },
  { label: 'IBODE', value: 'IBODE' },
  { label: 'ESF', value: 'ESF' },
  { label: 'IFIP', value: 'IFIP' },
  { label: 'CH', value: 'CH' },
  { label: 'CFAMA', value: 'CFAMA' },
  { label: 'Psychomotricité', value: 'Psychomotricité' },
  { label: 'Podologie', value: 'Podologie' },
  { label: 'Kinésithérapie', value: 'Kinésithérapie' },
  { label: 'IFSI', value: 'IFSI' },
  { label: 'EPPH', value: 'EPPH' },
  { label: 'IFMEM', value: 'IFMEM' },
  { label: 'Ostéopathie', value: 'Ostéopathie' },
  { label: 'Ergothérapie', value: 'Ergothérapie' },
  { label: 'IFAS', value: 'IFAS' },
  { label: 'SAMU', value: 'SAMU' },
  { label: 'CFARM', value: 'CFARM' },
  { label: 'IFTS', value: 'IFTS' },
  { label: 'CPS', value: 'CPS' },
];

const parcoursTypes = ['IFAS', 'SAMU', 'CFARM', 'CFAMA', 'CPS'];

const dates = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];

const FormatDate = (date) => {
  if (date === null || date === undefined) {
    return '/';
  }
  const _date = new Date(date);
  return `${_date.getDate()} ${dates[_date.getMonth()]} ${_date.getFullYear()}`;
};

const FormatDateWithYear = (date) => {
  if (date === null || date === undefined) {
    return '/';
  }
  const _date = new Date(date);
  return `${_date.getDate().toString().length > 1 ? _date.getDate() : `0${_date.getDate()}`}/${(_date.getMonth() + 1).toString().length > 1 ? (_date.getMonth() + 1) : `0${_date.getMonth() + 1}`}/${_date.getFullYear()}`;
};

const FormatDateOnlyYear = (date) => {
  if (date === null || date === undefined) {
    return '/';
  }
  const _date = new Date(date);
  return _date.getFullYear().toString();
};

const FormatTime = (date) => {
  const _date = new Date(date);
  return `${_date.getHours()}h${_date.getMinutes().toString().length === 1 ? `0${_date.getMinutes()}` : _date.getMinutes()}`;
};

const convertTime = (time) => {
  if (time !== undefined) {
    const timeArr = time.toString().split('.');
    let minutes;
    if (timeArr.length > 1) {
      if (timeArr[1] === '5') {
        minutes = '30';
      }
      if (timeArr[1] === '75') {
        minutes = '45';
      }
      if (timeArr[1] === '25') {
        minutes = '15';
      }
    }
    const string = `${timeArr[0]}h${minutes || ''}`;
    return string;
  }
  const string = `${0}h`;
  return string;
};

const checkErrors = (formObj, setErrors) => {
  const tempErrors = {};
  const formArr = Object.entries(formObj);
  let err = false;
  formArr.forEach((item) => {
    tempErrors[item[0]] = false;
    if (item[1].length === 0) {
      toastError('Valeur(s) manquante(s)');
      tempErrors[item[0]] = true;
      err = true;
    }
  });
  setErrors({ ...tempErrors });
  return err;
};

const doesSemesterExists = (_semester, table) => {
  let res = false;
  table.forEach((_sem) => {
    if (_sem.semester === parseInt(_semester.value, 10)) {
      res = true;
    }
  });
  return res;
};

const formatedSkillStatus = (status) => {
  switch (status) {
    case 0:
      return ['x', '', '', ''];
    case 1:
      return ['', 'x', '', ''];
    case 2:
      return ['', '', 'x', ''];
    case 3:
      return ['', '', '', 'x'];
    default:
      return ['', '', '', 'x'];
  }
};

function FileConvertSize(aSize) {
  const tmp = Math.abs(parseInt(aSize, 10));
  const def = [[1, 'octets'], [1024, 'ko'], [1024 * 1024, 'Mo'], [1024 * 1024 * 1024, 'Go'], [1024 * 1024 * 1024 * 1024, 'To']];
  for (let i = 1; i < def.length; i += 1) {
    if (tmp < def[i][0]) return `${(tmp / def[i - 1][0]).toFixed(2)} ${def[i - 1][1]}`;
  }
}

const FormatDateWithTime = (date) => {
  const _date = new Date(date);
  return `${_date.getDate()} ${dates[_date.getMonth()]} ${_date.getFullYear()} à ${_date.getHours()}h${_date.getMinutes().toString().length === 1 ? `0${_date.getMinutes()}` : _date.getMinutes()}`;
};

const FormatDateWithTimeShorter = (date) => {
  const _date = new Date(date);
  const day = _date.getDate().toString().length === 1 ? `0${_date.getDate()}` : _date.getDate();
  const month = (_date.getMonth() + 1).toString().length === 1 ? `0${_date.getMonth() + 1}` : _date.getMonth() + 1;
  const year = _date.getFullYear();
  return `${day}/${month}/${year} - ${_date.getHours()}h${_date.getMinutes().toString().length === 1 ? `0${_date.getMinutes()}` : _date.getMinutes()}`;
};

const capitalizeFirstLetter = (string) => string.charAt(0).toUpperCase() + string.slice(1);
const companiesType = ['IADE', 'IBODE', 'ESF', 'IFIP', 'CH', 'Podologie', 'Kinésithérapie', 'IFSI', 'EPPH', 'IFMEM', 'Ostéopathie', 'Ergothérapie', 'IFAS', 'SAMU', 'CFARM', 'CFAMA'].sort();

const sortObjetcArr = (arr, property) => arr.sort((a, b) => {
  if (a[property] < b[property]) {
    return -1;
  }
  if (a[property] > b[property]) {
    return 1;
  }
  return 0;
});

const calculateIndice = (beginningLevel, endLevel, hours) => {
  // 0-2,9 = 0,07
  // 3,0-3,9 = 0,01
  // 4,0-4,9 = 0,01
  // 5,0-6,4 = 0,01
  // 6,5-7,9 = 0,01
  // 8,0-8,9 = 0,00
  let indice;
  const newBeginningLevel = beginningLevel || 0;
  if (newBeginningLevel <= 2.9 && endLevel <= 2.9) {
    const progressionPerHour = 0.07;
    indice = hours * progressionPerHour;
    indice = (endLevel - newBeginningLevel) / indice;
  } else if (newBeginningLevel <= 2.9 && endLevel > 2.9) {
    const numberOfHoursByDecimal = 45 / 2.9; // nb of hours divided by number of decimals from 0 to 2.9, 15.5h or 1.5h per decimal
    // EXAMPLE:
    // 17h done in total, beginning level = 2.8, end level = 3.2
    // 2.9 - 2.8 = 0.1
    // 0.1 * 15,5 = 1.5 ==> nb of hours at 0.07
    // 17h - 1.5h = 15.5 ==> nb of hours at 0.01
    // indice = (1.5 * 0.07) + (15.5 * 0.01) ==> 0.26
    // indice = (3.2 - 2.8) / 0.26
    const decimalsBefore = 2.9 - newBeginningLevel;
    const nbHoursBefore = decimalsBefore * numberOfHoursByDecimal; // nb of hours at 0.07
    const nbHoursAfter = hours - nbHoursBefore; // nb of hours at 0.01
    indice = (nbHoursBefore * 0.07) + (nbHoursAfter * 0.01);
    indice = (endLevel - newBeginningLevel) / indice;
  } else if (newBeginningLevel > 2.9 && endLevel > 2.9 && newBeginningLevel < 8 && endLevel < 8) {
    const progressionPerHour = 0.01;
    indice = hours * progressionPerHour;
    indice = (endLevel - newBeginningLevel) / indice;
  } else if (newBeginningLevel > 2.9 && newBeginningLevel < 8 && endLevel >= 8) {
    const numberOfHoursByDecimal = 200 / 1.4;
    const decimalsBefore = 8 - newBeginningLevel;
    const nbHoursBefore = decimalsBefore * numberOfHoursByDecimal; // nb of hours at 0.07
    const nbHoursAfter = hours - nbHoursBefore; // nb of hours at 0.01
    indice = (nbHoursBefore * 0.01) + (nbHoursAfter * 0.003);
    indice = (endLevel - newBeginningLevel) / indice;
  } else if (newBeginningLevel >= 8 && endLevel >= 8) {
    const progressionPerHour = 0.003;
    indice = hours * progressionPerHour;
    indice = (endLevel - newBeginningLevel) / indice;
  }

  if (indice < 0.9) {
    return {
      content: indice.toFixed(1),
      rowSpan: 1,
      // styles: {
      //   fillColor: [245, 85, 85],
      // },
    };
  }
  if (indice >= 0.9 && indice <= 1.1) {
    return {
      content: indice.toFixed(1),
      rowSpan: 1,
      // styles: {
      //   fillColor: [255, 197, 89],
      // },
    };
  }
  if (indice > 1.1) {
    return {
      content: indice.toFixed(1),
      rowSpan: 1,
      // styles: {
      //   fillColor: [69, 219, 134],
      // },
    };
  }
  return {
    content: indice.toFixed(1),
    rowSpan: 1,
    // styles: {
    //   fillColor: [255, 255, 255],
    // },
  };
};

const formatMinutes = (minutes) => `${minutes / 60 > 0 ? Math.trunc(minutes / 60) : 0}h${minutes % 60 > 0 ? minutes % 60 : ''}`;

export {
  capitalizeFirstLetter,
  min2time,
  companiesType,
  time2min,
  sec2time,
  addUnitTimers,
  convertCEFRToElearningLevel,
  checkFields,
  Loading,
  generateCsv,
  numGradeToEUgrade,
  numGradeToEUgradeEW,
  exportXlsx,
  exportXlsxMultiSheet,
  createXlsx,
  generateWordDocument,
  types,
  parcoursTypes,
  FormatDate,
  FormatTime,
  convertTime,
  checkErrors,
  doesSemesterExists,
  formatedSkillStatus,
  FileConvertSize,
  FormatDateWithYear,
  FormatDateOnlyYear,
  FormatDateWithTime,
  FormatDateWithTimeShorter,
  levelToCEFR,
  sortObjetcArr,
  calculateIndice,
  formatMinutes,
};
